import axios from 'axios';
import { isEmpty } from 'lodash';
import { stringify } from 'query-string';

import * as Constants from '../../constants';
import { getConfig } from '../../reducers/portalConfig';
import { getValidationErrors } from '../../utils';
import { checkSession } from '../portalConfig';
import { AXIOS_DEFAULT_OPTIONS } from '..';

const init = (dispatch, isLoading = true) =>
  dispatch({
    type: Constants.APP_RESET,
    isLoading,
  });

export const resetApp = () => dispatch => dispatch({ type: Constants.APP_RESET });

export const resetAddKeyStore = () => dispatch => dispatch({ type: Constants.APP_RESET_KEY_STORE });

export const fetchKeyStoreList = ({
  name = null,
  keyStoreType = Constants.ALL,
  deploymentType = Constants.ALL,
  status = Constants.ALL,
  page = 0,
  size = 12,
} = {}) => async (dispatch, getState) => {
  init(dispatch);
  const config = getConfig(getState());
  const { portal } = config;
  const params = stringify({
    name: !isEmpty(name) ? name : undefined,
    keyStoreType: (keyStoreType !== Constants.ALL) ? keyStoreType : undefined,
    deploymentType: (deploymentType !== Constants.ALL) ? deploymentType : undefined,
    connectionStatus: (status !== Constants.ALL) ? status : undefined,
    page,
    size,
  }, true);


  const url = `${portal.hostname}/api/${portal.tenantPrefix}/deployments/1.0/key-stores?${params}`;
  await axios
    .get(url, AXIOS_DEFAULT_OPTIONS)
    .then((response) =>
      dispatch({
        type: Constants.KEY_STORE_LIST_GET_SUCCESS,
        payload: response.data,
      }),
    )
    .catch((error) =>
      dispatch({
        type: Constants.KEY_STORE_LIST_GET_ERROR,
        payload: getValidationErrors(error),
      }),
    );
};

export const fetchKeyStore = (uuid) => async (dispatch, getState) => {
  init(dispatch);
  const config = getConfig(getState());
  const { portal } = config;

  const url = `${portal.hostname}/api/${portal.tenantPrefix}/deployments/1.0/key-stores/${uuid}`;
  await axios
    .get(url, AXIOS_DEFAULT_OPTIONS)
    .then((response) =>
      dispatch({
        type: Constants.KEY_STORE_DETAILS_GET_SUCCESS,
        payload: response.data,
      }),
    )
    .catch((error) =>
      dispatch({
        type: Constants.KEY_STORE_DETAILS_GET_ERROR,
        payload: getValidationErrors(error),
      }),
    );
};

export const fetchKeyStoreKeyCounts = (uuid) => async (dispatch, getState) => {
  init(dispatch);
  const config = getConfig(getState());
  const { portal } = config;

  const url = `${portal.hostname}/api/${portal.tenantPrefix}/deployments/1.0/key-stores/${uuid}/details`;
  await axios
    .get(url, AXIOS_DEFAULT_OPTIONS)
    .then((response) =>
      dispatch({
        type: Constants.KEY_STORE_DETAILS_KEY_COUNTS_GET_SUCCESS,
        payload: response.data,
      }),
    )
    .catch((error) =>
      dispatch({
        type: Constants.KEY_STORE_DETAILS_KEY_COUNTS_GET_ERROR,
        payload: getValidationErrors(error),
      }),
    );
};

export const fetchProxyList = ({ uuid, filterByName,
  keyStoreName, deploymentType, hasAccess, page, size }) =>
  async (dispatch, getState) => {
   init(dispatch);
   const config = getConfig(getState());
   const { portal } = config;

   const params = stringify({
     proxyName: !isEmpty(filterByName) ? filterByName : undefined,
     keyStoreName: !isEmpty(keyStoreName) ? keyStoreName : undefined,
     keyStoreDeploymentType: deploymentType !== 'all' ? deploymentType : undefined,
     proxyKeyStoreAccessStatus: hasAccess ? 'ASSIGNED' : 'NOT_ASSIGNED',
     page,
     size,
   }, true);

   const url = `${portal.hostname}/api/${portal.tenantPrefix}/deployments/1.0/access/proxies-key-store/${uuid}?${params}`;
   await axios
     .get(url, AXIOS_DEFAULT_OPTIONS)
     .then((response) =>
       dispatch({
         type: Constants.KEY_STORE_DETAILS_PROXIES_LIST_GET_SUCCESS,
         payload: response.data,
       }),
     )
     .catch((error) =>
       dispatch({
         type: Constants.KEY_STORE_DETAILS_PROXIES_LIST_GET_ERROR,
         payload: getValidationErrors(error),
       }),
     );
 };


export const saveKeyStore =
  (name, deploymentType, keyStoreType, remoteStoreId) => async (dispatch, getState) => {
    init(dispatch);
    const config = getConfig(getState());
    const { portal } = config;
    const data = { name: name, deploymentType: deploymentType, keyStoreType: keyStoreType,
      remoteStoreId: remoteStoreId };
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/deployments/1.0/key-stores`;
    await axios
      .post(url, data, AXIOS_DEFAULT_OPTIONS)
      .then((response) => {
        dispatch({
          type: Constants.KEY_STORE_SAVE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: Constants.KEY_STORE_SAVE_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const updateKeyStore =
  (name, deploymentType, uuid, keyStoreType, remoteStoreId) => async (dispatch, getState) => {
    init(dispatch);
    const config = getConfig(getState());
    const { portal } = config;
    const data = { name: name, deploymentType: deploymentType,
      uuid: uuid, keyStoreType: keyStoreType, remoteStoreId: remoteStoreId };
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/deployments/1.0/key-stores/${uuid}`;
    await axios
      .put(url, data, AXIOS_DEFAULT_OPTIONS)
      .then((response) => {
        response = { data: { uuid: uuid } };
        dispatch({
          type: Constants.KEY_STORE_SAVE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: Constants.KEY_STORE_SAVE_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const updateKeyStoreProxy = ({ action, uuid, data }) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const actionParam = action === 'remove' ? '?action=remove' : '';
    const host = portal.hostname;
    const tId = portal.tenantPrefix;
    const url = `${host}/api/${tId}/deployments/1.0/key-stores/${uuid}/proxies${actionParam}`;
    dispatch({
      type: Constants.KEY_STORE_PROXY_UPDATE_ACCESS_REQUEST,
    });
    await axios.patch(url, data, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: Constants.KEY_STORE_PROXY_UPDATE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: Constants.KEY_STORE_PROXY_UPDATE_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

  export const deleteKeyStore = (uuid) => async (dispatch, getState) => {
    init(dispatch);
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal.hostname}/api/${portal.tenantPrefix}/deployments/1.0/key-stores/${uuid}`;
    await axios
      .delete(url, AXIOS_DEFAULT_OPTIONS)
      .then((response) =>
        dispatch({
          type: Constants.KEY_STORE_DELETE_SUCCESS,
          payload: response.data,
        }),
      )
      .catch((error) =>
        dispatch({
          type: Constants.KEY_STORE_DELETE_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

  export const fetchKeyDeploymentList = ({ uuid, name,
    apiKey, deploymentType, status, sortBy, page, size }) =>
    async (dispatch, getState) => {
     init(dispatch);
     const config = getConfig(getState());
     const { portal } = config;
     deploymentType = deploymentType.map(type => type.uuid);
     const params = stringify({
      apiKeyName: !isEmpty(name) ? name : undefined,
      apiKey: !isEmpty(apiKey) ? apiKey : undefined,
      apiKeyDeploymentStatus: deploymentType !== 'all' ? deploymentType : undefined,
      apiKeyStatus: status !== 'all' ? status : undefined,
      sort: sortBy,
      page,
      size,
     }, true);

      const url = `${portal.hostname}/api/${portal.tenantPrefix}/deployments/1.0/key-stores/${uuid}/api-keys?${params}`;
      await axios
        .get(url, AXIOS_DEFAULT_OPTIONS)
        .then((response) =>
          dispatch({
            type: Constants.KEY_STORE_KEY_DEPLOYMENTS_LIST_GET_SUCCESS,
            payload: response.data,
          }),
        )
        .catch((error) =>
          dispatch({
            type: Constants.KEY_STORE_KEY_DEPLOYMENTS_LIST_GET_ERROR,
            payload: getValidationErrors(error),
          }),
        );
  };

  export const deployApiKeyToKeyStore = (isDeploy, uuid) =>
    async (dispatch, getState) => {
      const config = getConfig(getState());
      const { portal } = config;
      const data = {};
      const host = portal.hostname;
      const tenant = portal.tenantPrefix;
      const isValidSession = await checkSession(getState());
      if (isValidSession) {
        const url =
        `${host}/api/${tenant}/deployments/1.0/key-stores/${uuid}/api-keys?forceDeploy=${isDeploy}`;

        await axios
        .post(url, data, AXIOS_DEFAULT_OPTIONS)
        .then((response) => {
          dispatch({
            type: Constants.KEY_STORE_KEY_BULK_DEPLOYMENTS_SUCCESS,
            payload: response.data,
          });
        })
        .catch((error) =>
          dispatch({
            type: Constants.KEY_STORE_KEY_BULK_DEPLOYMENTS_ERROR,
            payload: getValidationErrors(error),
          }),
        );
      } else {
        window.location.href =
          `${portal.hostname}/admin/login?to-default-config=true&referrer=${window.location.pathname}`;
      }
  };
